<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link
                v-if="$store.state.role != 'admin'"
                :to="{ name: 'organizationForeigners.create' }"
                class="btn btn-success ml-2"
                >ایجاد درخواست</router-link
            >
            <button class="btn btn-info mr-2" data-toggle="collapse" data-target="#advanced">
                جستجو پیشرفته
            </button>

            <div class="collapse fade mt-3" id="advanced">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>از تاریخ </label>
                            <Datepicker
                                simple
                                :max="maxDate"
                                auto-submit
                                id="fromDateTime"
                                locale="fa"
                                input-format="jYYYY/jMM/jDD"
                                v-model="fromDateTime"
                                :locale-config="{
                                    fa: {
                                        displayFormat: 'jYYYY/jMM/jDD'
                                    }
                                }"
                            />
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label> تا تاریخ </label>
                            <Datepicker
                                simple
                                :max="maxDate"
                                auto-submit
                                id="toDateTime"
                                locale="fa"
                                input-format="jYYYY/jMM/jDD"
                                v-model="toDateTime"
                                :locale-config="{
                                    fa: {
                                        displayFormat: 'jYYYY/jMM/jDD'
                                    }
                                }"
                            />
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label> وضعیت </label>
                        <select class="form-control" v-model="statusesId">
                            <option
                                :value="status.value"
                                v-for="(status, index) in statusListSearch"
                                :key="index"
                                >{{ status.value2 }}</option
                            >
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label>شرکت درخواست دهنده</label>
                        <select class="form-control" v-model="selectedCustomer">
                            <option
                                :value="item.id"
                                v-for="(item, index) in customerList"
                                :key="index"
                                >{{ item.title }}</option
                            >
                        </select>
                    </div>
                </div>
                <div class="row" style="display: flex; justify-content: end;">
                    <div
                        v-if="isAdvanced"
                        class="col-md-3"
                        style="display: flex; justify-content: end;"
                    >
                        <button
                            class="btn btn-danger"
                            v-on:click="removeFilter"
                            style="margin-top:29px"
                        >
                            حذف فیلتر
                        </button>
                    </div>
                    <div class="col-md-3">
                        <button
                            class="btn btn-primary w-100 mx-2"
                            style="margin-top:29px"
                            @click="search"
                        >
                            <i class="si si-magnifier"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>

            <hr class="w-100" />
            <div class="row mb-4">
                <div class="col-md-3">
                    <h5>
                        صفحه:
                        <select
                            name="paginate"
                            class="bg-gray-100 control"
                            id="paginate"
                            v-model="thisPage"
                            placeholder="1"
                            @change="getData"
                        >
                            <option v-for="(index, i) in this.totalFor" :key="index" selected>{{
                                i + 1
                            }}</option>
                        </select>
                        <span> از {{ this.totalFor }}</span>
                    </h5>
                </div>
                <div class="col-md-6 text-left">
                    <h5>
                        تعداد:
                        <select
                            name="paginate"
                            class="bg-gray-100 control"
                            id="paginate"
                            v-model="take"
                            placeholder="5"
                            @change="getData"
                        >
                            <option value="10">10</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                        </select>

                        از : {{ this.Total }}
                    </h5>
                </div>
                <div v-if="$store.state.role == 'admin'" class="col-md-3  text-right">
                    <button class="btn btn-outline-info w-100" @click="approveGroup">
                        <i class="ti ti-tick"></i>
                        تایید گروهی
                    </button>
                </div>
            </div>
            <Loading v-if="showLoading" />

            <div class="table-responsive" v-if="rows.length">
                <table class="table table-bordered table-hover mb-0">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th v-if="$store.state.role == 'admin'">
                                انتخاب رای تایید گروهی
                                <input type="checkbox" @change="selectAll" />
                            </th>
                            <th>
                                <a href="javascript:;" @click="reOrder(9)"
                                    >شناسه درخواست
                                    <i
                                        v-if="this.reOrderType && this.reOrderCol == 9"
                                        class=" ti-angle-up float-left"
                                    ></i>
                                    <i
                                        v-if="!this.reOrderType && this.reOrderCol == 9"
                                        class="float-left ti-angle-down"
                                    ></i>
                                </a>
                            </th>
                            <th>
                                <a href="javascript:;" @click="reOrder(2)"
                                    >نام
                                    <i
                                        v-if="this.reOrderType && this.reOrderCol == 2"
                                        class=" ti-angle-up float-left"
                                    ></i>
                                    <i
                                        v-if="!this.reOrderType && this.reOrderCol == 2"
                                        class="float-left ti-angle-down"
                                    ></i>
                                </a>
                            </th>
                            <th>
                                <a href="javascript:;" @click="reOrder(3)"
                                    >نام خانوادگی
                                    <i
                                        v-if="this.reOrderType && this.reOrderCol == 3"
                                        class=" ti-angle-up float-left"
                                    ></i>
                                    <i
                                        v-if="!this.reOrderType && this.reOrderCol == 3"
                                        class="float-left ti-angle-down"
                                    ></i>
                                </a>
                            </th>
                            <th>ملیت</th>
                            <th>
                                <a href="javascript:;" @click="reOrder(1)"
                                    >تاریخ ثبت
                                    <i
                                        v-if="this.reOrderType && this.reOrderCol == 1"
                                        class=" ti-angle-up float-left"
                                    ></i>
                                    <i
                                        v-if="!this.reOrderType && this.reOrderCol == 1"
                                        class="float-left ti-angle-down"
                                    ></i>
                                </a>
                            </th>
                            <th>
                                <a href="javascript:;" @click="reOrder(8)"
                                    >وضعیت
                                    <i
                                        v-if="this.reOrderType && this.reOrderCol == 8"
                                        class=" ti-angle-up float-left"
                                    ></i>
                                    <i
                                        v-if="!this.reOrderType && this.reOrderCol == 8"
                                        class="float-left ti-angle-down"
                                    ></i>
                                </a>
                            </th>
                            <th v-if="$store.state.role == 'admin'">ثبت کننده</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(request, index) in rows" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td v-if="$store.state.role == 'admin'">
                                <div v-if="request.status == 0">
                                    <input
                                        type="checkbox"
                                        @change="selectOrderId(request.id)"
                                        :checked="selectedOrderId.includes(request.id)"
                                        :value="request.id"
                                        :id="'orderIdSelect-' + request.id"
                                    />
                                </div>
                                <div v-else>-</div>
                            </td>
                            <td>{{ request.id }}</td>
                            <td>{{ request.firstName }}</td>
                            <td>{{ request.lastName || "-" }}</td>
                            <td>{{ request.nationality.title || "-" }}</td>
                            <td>{{ request.requestEventDate || "-" }}</td>
                            <td v-if="statusList.length > 0">
                                <span
                                    class="badge badge-warning"
                                    v-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 0
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-info"
                                    v-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 1
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-primary"
                                    v-else-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 2 &&
                                            request.apiCalls[0].lastResult &&
                                            request.apiCalls[0].lastResult != ''
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-dark"
                                    v-else-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 2
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-success"
                                    v-else-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 3
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-danger "
                                    style="cursor: pointer"
                                    data-toggle="modal"
                                    :data-target="`#modal1${request.id}`"
                                    v-else-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 4
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-info-light"
                                    v-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 5
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-pink"
                                    v-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 6
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                                <span
                                    class="badge badge-pill"
                                    v-if="
                                        statusList.find((item) => item.value === request.status) &&
                                            statusList.find((item) => item.value === request.status)
                                                .value == 7
                                    "
                                    >{{
                                        statusList.find((item) => item.value === request.status)
                                            .value2
                                    }}</span
                                >
                            </td>
                            <td v-else>-</td>
                            <td v-if="$store.state.role == 'admin'">
                                {{ request.consumer.title }}
                            </td>
                            <td>
                                <div class="row">
                                    <button class="btn btn-icon py-0">
                                        <router-link
                                            class="nav-link"
                                            target="_blank"
                                            :to="{
                                                name: 'organizationForeigners.view',
                                                params: { id: request.id }
                                            }"
                                            ><span class="shape1"></span><span class="shape2"></span
                                            ><i class="ti-eye"></i
                                        ></router-link>
                                    </button>

                                    <button
                                        class="btn btn-outline-secondary mx-1"
                                        v-if="
                                            request.status === 4 &&
                                                request.description === 'تحت بررسی'
                                        "
                                        data-toggle="modal"
                                        :data-target="`#modal2${request.id}`"
                                    >
                                        استعلام مجدد
                                    </button>

                                    <button
                                        v-if="
                                            (request.status === 1 || request.status === 2) &&
                                                request.apiCalls[0].lastResult &&
                                                request.apiCalls[0].lastResult != ''
                                        "
                                        data-toggle="modal"
                                        :data-target="`#modal0${request.id}`"
                                        class="btn btn-danger py-0"
                                    >
                                        <i class="ti-alert"></i>
                                    </button>

                                    <button
                                        v-if="
                                            (request.status === 1 || request.status === 2) &&
                                                request.apiCalls[0].lastResult &&
                                                request.apiCalls[0].lastResult != ''
                                        "
                                        data-toggle="modal"
                                        :data-target="`#modal0${request.id}`"
                                        class="btn btn-danger py-0"
                                    >
                                        <i class="ti-alert"></i>
                                    </button>

                                    <button
                                        v-if="request.status == 0 && $store.state.role == 'admin'"
                                        v-on:click="approveUser(request.id)"
                                        class="btn btn-outline-success mr-1"
                                    >
                                        تایید کاربر
                                    </button>
                                    <button
                                        v-if="request.status == 0 && $store.state.role == 'admin'"
                                        data-toggle="modal"
                                        :data-target="'#modal-description'"
                                        class="btn btn-outline-danger mr-1"
                                    >
                                        عدم تایید کاربر
                                    </button>
                                </div>
                            </td>

                            <div
                                class="modal effect-scale col-md-12"
                                :id="'modal-description'"
                                aria-hidden="true"
                            >
                                <div
                                    class="modal-dialog modal-lg modal-dialog-centered"
                                    role="document"
                                >
                                    <div class="modal-content modal-content-demo">
                                        <div class="modal-header">
                                            <h6>لطفا توضیحات خود را وارد نمایید</h6>
                                            <button
                                                aria-label="بستن"
                                                class="close"
                                                data-dismiss="modal"
                                                type="button"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div class="row m-0" style="display: flex;">
                                            <form
                                                class="form-group col-12"
                                                style="margin-top: 16px;"
                                                v-on:submit.prevent="rejectUser(request.id)"
                                            >
                                                <div class="form-group col-6">
                                                    <label> توضیحات </label>
                                                    <input
                                                        class="form-control"
                                                        style="min-height: 100px;"
                                                        v-model="description"
                                                    />
                                                </div>
                                                <div
                                                    class="col-12"
                                                    style="display: flex; justify-content: end;"
                                                >
                                                    <button
                                                        :disabled="!description"
                                                        type="submit"
                                                        class="btn btn-success w-25 my-4 px-3 py-2 mr-1"
                                                    >
                                                        <i class="ti-tick text-white">تایید </i>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="request.description"
                                class="modal effect-scale"
                                :id="`modal1${request.id}`"
                                aria-hidden="true"
                            >
                                <div
                                    class="modal-dialog modal-dialog-centered"
                                    role="document"
                                    style="width:600px !important"
                                >
                                    <div
                                        class="modal-content modal-content-demo"
                                        style="width:600px !important"
                                    >
                                        <div class="modal-header">
                                            <h6 class="modal-title">
                                                نمایش توضیحات {{ request.firstName }}
                                                {{ request.lastName || "-" }}
                                            </h6>
                                            <button
                                                aria-label="بستن"
                                                class="close"
                                                data-dismiss="modal"
                                                type="button"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <h4 class="text-center text-danger">
                                                            {{ request.description }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="modal effect-scale"
                                :id="`modal0${request.id}`"
                                aria-hidden="true"
                            >
                                <div
                                    class="modal-dialog modal-dialog-centered"
                                    role="document"
                                    style="width:600px !important"
                                >
                                    <div
                                        class="modal-content modal-content-demo"
                                        style="width:600px !important"
                                    >
                                        <div class="modal-header">
                                            <h6 class="modal-title">
                                                نمایش خطاهای {{ request.firstName }}
                                                {{ request.lastName || "-" }}
                                            </h6>
                                            <button
                                                aria-label="بستن"
                                                class="close"
                                                data-dismiss="modal"
                                                type="button"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div
                                                        v-if="request.apiCalls.length > 0"
                                                        class="form-group"
                                                    >
                                                        <h4
                                                            v-if="request.apiCalls.length > 0"
                                                            class="text-center text-danger"
                                                        >
                                                            {{ request.apiCalls[0].lastResult }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="modal effect-scale"
                                :id="`modal2${request.id}`"
                                aria-hidden="true"
                            >
                                <div
                                    class="modal-dialog modal-dialog-centered"
                                    role="document"
                                    style="width:600px !important"
                                >
                                    <div
                                        class="modal-content modal-content-demo"
                                        style="width:600px !important"
                                    >
                                        <div class="modal-header">
                                            <h6 class="modal-title">درخواست مجدد کد فیدا</h6>
                                            <button
                                                aria-label="بستن"
                                                class="close"
                                                data-dismiss="modal"
                                                type="button"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <h4>
                                                            آیا می خواهید دوباره کد فیدا دریافت
                                                            کنید؟
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="row"
                                                style="display: flex; justify-content: end;"
                                            >
                                                <button
                                                    class="btn btn-secondary mx-2"
                                                    data-dismiss="modal"
                                                    v-on:click="recheck(request.id)"
                                                    style="margin-top:29px"
                                                    @click="getFidaCode"
                                                >
                                                    دریافت
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="alert alert-info mb-0" v-if="rows.length === 0 && !showLoading">
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
    name: "Index",
    data() {
        return {
            rows: [],
            customerList: [],
            selectedOrderId: [],
            selectedCustomer: 0,
            Total: 0,
            totalFor: 0,
            showLoading: false,
            fromDateTime: "",
            toDateTime: "",
            isAdvanced: false,
            statusesId: 100,
            statusList: [],
            statusListSearch: [],
            personIdFromModel: 0,
            personalImg: "",
            passportImg: "",
            thisPage: 1,
            take: 30,
            reOrderType: true,
            reOrderCol: 9,
            maxDate: moment().format("jYYYY/jMM/jDD"),
            description: ""
        };
    },
    methods: {
        async getCustomerList() {
            const body = {
                authorizationToken: localStorage.getItem("agc-token"),
                consumerId: 0,
                isAdmin: 100,
                name: "",
                tourist: 100,
                switch: 0,
                status: 100
            };
            this.$api
                .post("Organizations/Fida/Consumer/List", body)
                .then(({ data }) => {
                    if (data.status) {
                        this.customerList = data.result
                            ? [{ id: 0, title: "همه" }, ...data.result]
                            : [];
                    }
                })
                .catch(() => {
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: " داده ای  یافت نشد ,لذا مجدد اقدام کنید!"
                    });
                });
        },
        selectOrderId(id) {
            if (this.selectedOrderId.includes(id)) {
                this.selectedOrderId.splice(this.selectedOrderId.indexOf(id), 1);
            } else {
                this.selectedOrderId = [...this.selectedOrderId, id];
            }
        },
        async getStatusList() {
            this.$api.get("Organizations/Fida/LookUp/GetStatusList").then(({ data }) => {
                if (data.status) {
                    (this.statusList = data.result),
                        (this.statusListSearch = [
                            { value: 100, value2: "همه", title: "all" },
                            ...data.result
                        ]);
                }
            });
        },
        async approveGroup() {
            const body = {
                authenticationToken: localStorage.getItem("agc-token"),
                personId: this.selectedOrderId
            };
            this.$api
                .post("Organizations/Fida/Person/ApproveList", body)
                .then(({ data }) => {
                    if (data.status) {
                        this.selectedOrderId.map((item) => {
                            document.getElementById("orderIdSelect-" + item).checked = false;
                        });
                        this.selectedOrderId = [];
                    }
                    this.getData();
                })
                .catch(() => {
                    this.selectedOrderId.map((item) => {
                        document.getElementById("orderIdSelect-" + item).checked = false;
                    });
                });
        },
        selectAll(e) {
            if (e.target.checked) {
                let ids = [];
                this.rows.forEach((row) => {
                    if (row.status == 0) ids.push(row.id);
                });
                this.selectedOrderId = ids;
            } else this.selectedOrderId = [];
        },
        async getData() {
            this.showLoading = true;
            const body = {
                authorizationToken: localStorage.getItem("agc-token"),
                fromDateTime: this.fromDateTime
                    ? moment(this.fromDateTime, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss")
                    : "",
                toDateTime: this.toDateTime
                    ? moment(this.toDateTime, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss")
                    : "",
                statusId: this.statusesId,
                consumerId: this.selectedCustomer,
                take: this.take,
                page: this.thisPage,
                reOrderType: this.reOrderType,
                reOrderCol: this.reOrderCol
            };

            this.$api
                .post("Organizations/Fida/Person/List", body)
                .then(({ data }) => {
                    if (data.status) {
                        this.showLoading = false;
                        this.rows = data.result.list;
                        this.Total = data.result.totalCount;
                        this.totalFor = parseInt(data.result.totalCount / this.take) + 1;
                    }
                    this.showLoading = false;
                })
                .catch(() => {
                    this.showLoading = false;
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: " داده ای  یافت نشد ,لذا مجدد اقدام کنید!"
                    });
                });
        },
        async rejectUser(id) {
            this.showLoading = true;
            this.$api
                .post("Organizations/Fida/Person/Reject", {
                    authorizationToken: localStorage.getItem("agc-token"),
                    personId: parseInt(id),
                    description: this.description
                })
                .then(({ data }) => {
                    if (data.status) {
                        location.reload();
                    }
                })
                .catch(() => {
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: "مجددا اقدام کنید!"
                    });
                });
            this.showLoading = false;
        },
        async approveUser(id) {
            this.$dialog.confirm("آیا از درخواست خود اطمینان دارید ؟ ").then((dialog) => {
                this.showLoading = true;
                this.$api
                    .post("Organizations/Fida/Person/Approve", {
                        authorizationToken: localStorage.getItem("agc-token"),
                        personId: parseInt(id)
                    })
                    .then(({ data }) => {
                        if (data.status) {
                            location.reload();
                        }
                    })
                    .catch(() => {
                        this.$swal({
                            title: "ناموفق",
                            icon: "error",
                            text: "مجددا اقدام کنید!"
                        });
                    })
                    .finally(() => {
                        this.showLoading = false;
                        if (dialog) {
                            dialog.close();
                        }
                    });
            });
        },
        selectPersonIdFromModel(item) {
            const body = {
                personId: item
            };
            this.$api.post("Organizations/Fida/Person/Documents", body).then(({ data }) => {
                if (data.status) {
                    this.personalImg = `data:image/png;base64,${
                        data.result.find((item) => item.value === 1).value2
                    }`;
                    this.passportImg = `data:image/png;base64,${
                        data.result.find((item) => item.value === 6).value2
                    }`;
                }
            });
        },

        search() {
            this.thisPage = 1;
            this.getData();
            this.isAdvanced = true;
        },
        removeFilter() {
            this.toDateTime = "";
            this.fromDateTime = "";
            this.isAdvanced = false;
            this.statusesId = 0;
            this.getData();
        },
        async recheck(id) {
            this.showLoading = true;
            const body = {
                authorizationToken: localStorage.getItem("agc-token"),
                personId: id
            };
            this.$api.post("Organizations/Fida/Inquiry/FidaCode", body).then(({ data }) => {
                if (data.status) {
                    this.showLoading = false;
                    this.$swal({
                        title: "عملیات موفق",
                        icon: "success",
                        text: "بروزرسانی انجام شد!"
                    }).then(() => {
                        this.getData();
                    });
                } else {
                    this.$swal({
                        title: "خطا!",
                        icon: "error",
                        text: "بروزرسانی با خطا مواجه شد!"
                    }).then(() => {});
                }
                this.showLoading = false;
            });
        },
        reOrder(cell) {
            this.reOrderCol = cell;
            this.reOrderType = !this.reOrderType;
            this.getData();
        }
    },
    created() {
        this.getCustomerList();
        this.getStatusList();
        this.getData();
    }
};
</script>
